import { AgentActivityWebService } from '@linktivity/gds-neo';

type ActivitiesLang = AgentActivityWebService.SearchActivitiesLangEnum;
const ActivitiesLang = AgentActivityWebService.SearchActivitiesLangEnum;

type ActivitiesCategories =
  AgentActivityWebService.SearchActivitiesCategoriesEnum;
const ActivitiesCategories =
  AgentActivityWebService.SearchActivitiesCategoriesEnum;

type CustomFieldCollectingType =
  AgentActivityWebService.CustomFieldCollectingType;
const CustomFieldCollectingType =
  AgentActivityWebService.CustomFieldCollectingType;

type FileType = AgentActivityWebService.FileType;
const FileType = AgentActivityWebService.FileType;

type SearchActivitiesBookingTypeEnum =
  AgentActivityWebService.SearchActivitiesBookingTypeEnum;
const SearchActivitiesBookingTypeEnum =
  AgentActivityWebService.SearchActivitiesBookingTypeEnum;

type CollectingTiming = AgentActivityWebService.CollectingTiming;
const CollectingTiming = AgentActivityWebService.CollectingTiming;

export {
  ActivitiesLang,
  ActivitiesCategories,
  CustomFieldCollectingType,
  FileType,
  SearchActivitiesBookingTypeEnum,
  CollectingTiming
};
